<template>
  <div class="pointer" :class="{hide: isHover}" ref="pointer">
    <span></span>
  </div>
</template>

<script>
import { throttle } from 'lodash'
export default {
  data () {
    return {
      isHover: false
    }
  },
  methods: {
    placePointer: function (e) {
      this.$refs.pointer.style.left = e.clientX + 'px'
      this.$refs.pointer.style.top = e.clientY + 'px'
    },
    handleMouseMove: throttle(function (e) {
      var elm = document.elementFromPoint(e.clientX, e.clientY)
      if (elm === null) return
      if (elm.classList.contains('pointer-target') === true) {
        this.isHover = false
      } else {
        this.isHover = true
      }
    }, 100)
  },
  mounted () {
    if (navigator.userAgent.indexOf('iPhone') < 0) {
      document.addEventListener('mousemove', this.placePointer)
      document.addEventListener('mousemove', this.handleMouseMove)
    }
  },
  beforeDestroy () {
    document.removeEventListener('mousemove', this.placePointer)
    document.removeEventListener('mousemove', this.handleMouseMove)
  }
}
</script>

<style lang="scss">
.pointer-target {
  cursor: none!important;
}
</style>
<style lang="scss" scoped>
@font-face {
  font-family: 'site';
  src: url('../assets/fonts/site.eot?17746080');
  src: url('../assets/fonts/site.eot?17746080#iefix') format('embedded-opentype'),
       url('../assets/fonts/site.woff2?17746080') format('woff2'),
       url('../assets/fonts/site.woff?17746080') format('woff'),
       url('../assets/fonts/site.ttf?17746080') format('truetype'),
       url('../assets/fonts/site.svg?17746080#site') format('svg');
  font-weight: normal;
  font-style: normal;
}
.pointer {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  &.hide {
    opacity: 0;
    transform: scale(0.9);
  }
  &.over {
    span {
      transform: scale(3);
      border: none;
      background: rgba(0, 0, 0, 0.5);
      mix-blend-mode: difference;
    }
  }
  span {
    width: 30px;
    height: 30px;
    margin: -15px 0 0 -15px;
    display: block;
    transition: transform, 0.3s ease-out;
    transform: rotate(180deg);
    line-height: 1;
    // background-color: rgba(#fff, 0.5);
    border-radius: 100%;
    &:before {
      font-family: 'site';
      content: '\e800';
      font-size: 30px;
      color: #FFF;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PlvPointer.vue